export const createAccountCode =
`
  <CreateAccount onSubmit={handleCreateAccountSubmit}/>
`;

export const loginCode =
`
  <LoginForm onSubmit={handleLoginFormSubmit}/>
`;

export const creditCardCode =
`
  <CreditCardForm onSubmit={handleCreditCardFormSubmit}/>
`;

export const wizardCode =
`
  <Form className="wizard-form">
    <WizardForm
      className="main-content"
      label={{
        highlighted: 'Need Solutions?',
        text: 'Share your details with us.'
      }}
      inputs={[
        {
          placeholder: 'name',
          name: 'name',
          id: 'name',
        },
        {
          placeholder: 'email',
          name: 'email',
          id: 'email',
        },
        {
          placeholder: 'location',
          name: 'location',
          id: 'location',
        }
      ]}
    />
  </Form>
`;

export const suggestionBoxCode =
`
  <SuggestionBoxForm className={containerClassHere} />
`;




// WEBPACK FOOTER //
// ./src/containers/components/Form/constants/formsCode.js